var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.noData)?_c('v-row',{staticClass:"pt-10"},[_c('v-spacer'),_vm._v("No matching records found! "),_c('v-spacer')],1):_vm._e(),_c('canvas',{staticClass:"report-card-chart",attrs:{"id":'barChartReport' + _vm.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }